import { render, staticRenderFns } from "./page12.vue?vue&type=template&id=53b64556&scoped=true&"
import script from "./page12.vue?vue&type=script&lang=js&"
export * from "./page12.vue?vue&type=script&lang=js&"
import style0 from "./page12.vue?vue&type=style&index=0&id=53b64556&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b64556",
  null
  
)

export default component.exports